import type { ClientStatus, Job, PaymentTransaction } from '@workflow/contracts'
import type { StatusTone } from '@workflow/ui'

/**
 * How each client status is shown — the same silhouettes the account
 * statuses use, so one scan reads both: live, quiet, or withdrawn.
 */
export const CLIENT_STATUS: Record<ClientStatus, { label: string; tone: StatusTone }> = {
  active: { label: 'Active', tone: 'done' },
  inactive: { label: 'Inactive', tone: 'waiting' },
  archived: { label: 'Archived', tone: 'idle' },
}

/**
 * A client's name where their work is listed, saying what became of them: an
 * archived client is still on file, a deleted one is only a name the work
 * kept. Work with no client reads as internal.
 */
export function clientLabel(
  row: Pick<Job, 'clientName' | 'clientDeleted' | 'clientArchived'>,
  none = 'Internal',
): string {
  if (row.clientName === null) return none
  if (row.clientDeleted) return `${row.clientName} (deleted client)`
  if (row.clientArchived) return `${row.clientName} (archived)`
  return row.clientName
}

/** The same, for a payment row, which knows only whether the client was deleted. */
export function paymentClientLabel(row: Pick<PaymentTransaction, 'clientName' | 'clientDeleted'>, none: string): string {
  if (row.clientName === null) return none
  return row.clientDeleted ? `${row.clientName} (deleted client)` : row.clientName
}
